module.exports = __webpack_public_path__ + "static/media/Sarah_Elrabaa_DDS.568ced7e.png";